import { Transform, Type } from 'class-transformer';
import {
	IsArray,
	IsBoolean,
	IsNumber,
	IsObject,
	IsOptional,
	IsString,
	Min,
} from 'class-validator';

export class GetIssuesRequestDto {
	@Type(() => Number)
	@IsNumber()
	@Min(1)
	@IsOptional()
	public limit: number = 25;

	@Type(() => Number)
	@IsNumber()
	@Min(1)
	@IsOptional()
	public page: number = 1;

	@Transform(({ value }) => {
		if (typeof value === 'string') {
			return JSON.parse(value) as GetIssuesRequestDto['filters'];
		}

		return value as unknown;
	})
	@IsObject()
	@IsOptional()
	public filters?: {
		issueKeywords?: string;
		issueStatus?: Array<string>;
		issueType?: Array<string>;
		issueClient?: Array<number>;
		issueAssignee?: Array<string>;
		issueClientSalesRep?: Array<string>;
		/** PD-16475 — company ids (issue.fk_company__id). */
		issueCompany?: Array<number>;
		issueCreatedDateRange?: {
			from?: string;
			to?: string;
		};
	};

	@Transform(({ value }) => {
		if (typeof value === 'string') {
			return JSON.parse(value) as GetIssuesRequestDto['sortFields'];
		}

		return value as unknown;
	})
	@IsArray()
	@IsOptional()
	public sortFields?: Array<{
		objectTable: string;
		fieldName: string;
		direction: 'ASC' | 'DESC';
	}>;

	@Transform(({ value }) => value === 'true' || value === true)
	@IsBoolean()
	@IsOptional()
	public countOnly?: boolean;

	@IsOptional()
	@IsString()
	public cacheKey?: string = 'default';

	@Transform(({ value }) => (value != null ? Number(value) : 600000))
	@IsNumber()
	@IsOptional()
	public cacheTTL?: number = 600000;

	@IsOptional()
	@IsString()
	public listId?: string;

	@IsOptional()
	@IsArray()
	@IsString({ each: true })
	public fields?: Array<string>;

	@IsOptional()
	@IsArray()
	public clientSalesRepIds?: Array<number>;

	@IsOptional()
	@IsArray()
	public assigneeUserIds?: Array<number>;
}
